import React from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';

interface RouteLoadingGateProps {
  message?: string;
  minHeight?: string | number;
}

/**
 * Consistent loading state for route guards (auth, MSME, workflow) with an accessible status message.
 */
const RouteLoadingGate: React.FC<RouteLoadingGateProps> = ({
  message = 'Loading…',
  minHeight = '45vh',
}) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight,
      px: 2,
    }}
  >
    <Stack spacing={2} alignItems="center" sx={{ maxWidth: 400 }}>
      <CircularProgress aria-label={message} />
      {message ? (
        <Typography variant="body2" color="text.secondary" textAlign="center">
          {message}
        </Typography>
      ) : null}
    </Stack>
  </Box>
);

export default RouteLoadingGate;
